export const getAutoResponse = (index, data, customerEmail) => {
    const answer = data.questionList[index].answers[0];
    const question = data.questionList[index];
    const cta = data.questionList[index].cta.filter((cta) => cta.ctaType === "next" || cta.ctaType === "submit")[0];
    const response = {
        _id: answer?._id || "",
        inputType: "email",
        inputValue: customerEmail,
        tag: answer?.tag || "",
        inputLabel: answer?.label || "",
        inputRequired: answer.required !== undefined ? answer.required : true
    }
    return {
        questionType: question.type,
        questionText: question.questionText,
        nextQuestionId: cta?.linkedQuestionId || '',
        _id: question._id,
        action: "autoSubmit",
        answerResponse: [response],
        selfieResponse: [],
        selfieID: '',
        userSelfie: '',
        timeStamp: new Date().getTime()
    }
}
